import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';

/** @package */
export const PARAMETER_COLUMN_DEF: DataFrameColumnDef = {
  systemName: 'parameter',
  displayName: 'Parameter',
  type: {
    leafType: LeafType.TEXT,
  },
};

/** @package */
export const SHAP_VALUE_Y_AXIS_LABEL = 'Contribution';
export const SHAP_VALUE_COLUMN_SYSTEM_NAME = 'shap_value';
